import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

// The Spalogy symbol: a fine circle crossed by a gentle wave.
const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 64 40'
            fill='none'
            aria-hidden='true'
            className={cn('h-7 w-auto', className)}
        >
            <circle cx='32' cy='20' r='15' stroke='currentColor' strokeWidth='1.1' />
            <path
                d='M2 22.2C12.5 18.6 21 18.4 32 20.6C43 22.8 51.5 22.6 62 18.8'
                stroke='currentColor'
                strokeWidth='1.1'
                strokeLinecap='round'
            />
        </svg>
    )
}

export default LogoMark
